// extracted by mini-css-extract-plugin
export default {"ExpiredContacts":"ExpiredContacts_ExpiredContacts__xltFm","header":"ExpiredContacts_header__QOQQ3"};